import styled from 'styled-components';
import headerImage from 'assets/images/header-image.jpg';
import headerImageMobile from 'assets/images/header-image-mobile.jpg';
import arrowDown from 'assets/images/arrow-down.svg';
import { fonts } from 'styles';

export const Container = styled.main`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
`;

export const Header = styled.header`
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const HeaderImageLegend = styled.span`
  position: absolute;
  right: 24px;
  bottom: 24px;
  font-size: 14px;
  color: #ffffff;
`;

export const HeaderImage = styled.img.attrs({ src: headerImage })`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: fixed;
  z-index: -1;
  @media (max-width: 500px) {
    display: none;
  }
`;

export const HeaderImageMobile = styled.img.attrs({ src: headerImageMobile })`
  display: none;
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: fixed;
  z-index: -1;
  @media (max-width: 500px) {
    display: block;
  }
`;

export const ArrowIcon = styled.img.attrs({ src: arrowDown })`
  position: absolute;
  bottom: 56px;
  transition: 300ms;
  animation-name: jump;
  animation-duration: 700ms;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  @keyframes jump {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-5px);
    }
  }
`;

export const Eye = styled.section`
  width: 100%;
  background-color: #0861f5;
  padding: 120px 40px 96px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 500px) {
    padding: 72px 40px;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 72px;
  line-height: 64px;
  text-align: center;
  text-transform: uppercase;
  color: #f7e6d4;
  margin-bottom: 40px;

  @media screen and (max-width: 500px) {
    font-size: 36px;
    line-height: 34px;
  }
`;

export const EyeText = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 18px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  margin-bottom: 32px;
  max-width: 570px;
`;

export const EyeAuthor = styled.span`
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
`;

export const Content = styled.section`
  width: 100%;
  margin: 0 auto;
  padding: 96px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #070707;

  @media screen and (max-width: 500px) {
    padding: 72px 40px;
  }
`;

export const ContentText = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 24px;
  max-width: 610px;
  margin-bottom: 124px;

  p {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: #fff;
    text-decoration: underline;
  }
`;
